var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header",style:({ backgroundImage: 'url(' + _vm.backgroundImage + ')' })},[_c('div',{staticClass:"header__container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }